var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1079_2082)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.08138 0.198762C1.02421 0.137407 0.955264 0.0881946 0.87866 0.0540623C0.802056 0.01993 0.719362 0.00157664 0.635511 9.71894e-05C0.55166 -0.00138227 0.46837 0.0140423 0.390609 0.0454511C0.312849 0.0768598 0.242211 0.123609 0.18291 0.18291C0.123609 0.242211 0.0768598 0.312849 0.0454511 0.390609C0.0140423 0.46837 -0.00138227 0.55166 9.71894e-05 0.635511C0.00157664 0.719362 0.01993 0.802056 0.0540623 0.87866C0.0881946 0.955264 0.137407 1.02421 0.198762 1.08138L2.52355 3.407C1.81614 3.54899 1.17974 3.93158 0.722531 4.48974C0.265319 5.0479 0.0155129 5.74717 0.0155776 6.46868V13.5463C0.0155776 14.3744 0.344551 15.1686 0.930128 15.7542C1.5157 16.3398 2.30992 16.6688 3.13805 16.6688H10.2156C10.9372 16.6688 11.6364 16.419 12.1946 15.9618C12.7527 15.5046 13.1353 14.8682 13.2773 14.1608L18.9327 19.817C19.0499 19.9342 19.2088 20 19.3745 20C19.5402 20 19.699 19.9342 19.8162 19.817C19.9334 19.6999 19.9992 19.541 19.9992 19.3753C19.9992 19.2096 19.9334 19.0507 19.8162 18.9336L1.08138 0.198762ZM5.99656 3.34621L13.3381 10.6878V6.46868C13.3381 5.64055 13.0091 4.84634 12.4236 4.26076C11.838 3.67519 11.0438 3.34621 10.2156 3.34621H5.99656ZM14.1708 11.5204L18.4814 15.8319C19.2583 15.8602 19.9961 15.2516 19.9961 14.3731V5.63852C19.9961 4.46447 18.678 3.7717 17.7112 4.43949L14.1708 6.88418V11.5204Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1079_2082"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraDisabled);
export default __webpack_public_path__ + "static/media/camera-disabled.219432f40d459e6765c7403d92461f53.svg";
export { ForwardRef as ReactComponent };